import { Component, Input, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { NotamDetailsComponent } from '../notam-details/notam-details.component';
import { NOTAM } from '../models/notam.model';

@Component({
  selector: 'app-notams',
  templateUrl: './notams.component.html',
  styleUrls: ['./notams.component.scss']
})
export class NotamsComponent implements OnInit {
  @Input() airport: Airport;

  getNOTAMs(): NOTAM[] {
    if (this.airport.country === 'US') {
      return this.airport.notamsUS;
    } else {
      return this.airport.notamsInternational;
    }
  }

  getNOTAMCount(): number {
    if (this.airport.country === 'US') {
      return this.airport.notamCountUS;
    } else {
      return this.airport.notamCountInternational;
    }
  }

  constructor(private _dialog: MatDialog) { }

  ngOnInit() {
  }

  showAllNotams() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      FaaId: this.airport.faaId,
      country: this.airport.country
    };
    const dialogRef = this._dialog.open(NotamDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
    });
  }

}
